import { render } from "./index.vue?vue&type=template&id=21db496e&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=21db496e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21db496e"]])

export default __exports__